import {renderTime} from '@modules/liveControl/components/LiveControlTable/renderTime';
import {renderContent} from '@modules/liveControl/components/LiveControlTable/renderContent';

export const rowRenderer = (column, row) => {
    switch (column) {
        case 'event_content_start_datetime':
            return renderTime(row);
        case 'content':
            return renderContent(row);
    }
};
